export default {
  setPageName(state, value) {
    state.pageName = value
  },
  setClassID(state, value) {
    state.classID = value
  },
  setUserName(state, value) {
    state.userName = value
  },
  setUserMobile(state, value) {
    state.userMobile = value
  },
  setUserID(state, value) {
    state.userID = value
  },
}



// WEBPACK FOOTER //
// ./src/store/common/mutations.js